import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@/assets/iconfonts/css/delight-mdi.css';
import '@/assets/scss/main.scss';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#48d7b6',
        // primary: '#3dc7b2',
        secondary: '#e6dfd1',
        tertiary: '#fbfbfb',
        accent: '#7ed9c5',
        error: '#ec6a41',
        info: '#8c9eff',
        success: '#1abb9c',
        warning: '#ffd13f',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
